import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Menu } from 'antd';
import { Link, withRouter } from 'react-router-dom';
import { gql, graphql } from 'react-apollo';


class AnalyticsMenu extends React.Component {
  render() {
    const { location } = this.props
    const isAdmin = this.props.data && this.props.data.user && ~this.props.data.user.groupsList.indexOf('admins')
    return (
      <Menu selectedKeys={[location.pathname.replace(/\/(lead)?$/, '')]} mode="horizontal" className='analytics-menu'>
        <Menu.Item key="/dashboard/analytics">
          <Link to="/dashboard/analytics">
            <FormattedMessage id='main-menu.analytics' defaultMessage='Analytics'/>
          </Link>
        </Menu.Item>
        <Menu.Item key="/dashboard/analytics/audit">
          <Link to="/dashboard/analytics/audit">
            <FormattedMessage id='main-menu.analytics-audit' defaultMessage='Audit'/>
          </Link>
        </Menu.Item>
        {isAdmin && <Menu.Item key="/dashboard/analytics/gfm">
          <Link to="/dashboard/analytics/gfm">
            <FormattedMessage id='main-menu.gfm' defaultMessage='GFM'/>
          </Link>
        </Menu.Item>}
      </Menu>
    );
  }
}

const USER_QUERY = gql`query {
    user {
      id
      groupsList
    }
  }
`;

const withUserPermission = graphql(USER_QUERY, {
  options: () => ({ variables: {}}),
});

export default withRouter(withUserPermission(AnalyticsMenu))


// WEBPACK FOOTER //
// ./src/components/dashboard/analytics/menu.js